import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import AllRoutes from "./AllRoutes";
import "./App.css";
import { useEffect, useState } from "react";
import { fetchAllQuestions } from "./actions/question";
import { useDispatch } from "react-redux";
import { fetchAllUsers } from "./actions/users";

function App() {
  const [showNav, setShowNav] = useState(false);
  const dispatch = useDispatch();

  const handleShowNav = () => {
    setShowNav(!showNav);
  };

  useEffect(() => {
    dispatch(fetchAllQuestions());
    dispatch(fetchAllUsers());
  }, [dispatch]);

  return (
    <div className="App">
      <Router>
        <Navbar showNav={showNav} handleShowNav={handleShowNav} />
        <AllRoutes showNav={showNav} />
      </Router>
    </div>
  );
}

export default App;
